export const TaskStatusColors = {
  CompletedOnTime: "#7ADD3E",
  CompletedLate: "#EEA813",
  CompletedEarly: "#8A48D5",
  Missed: "#E71D2F",
  Future: "#22B0D6",
} as const;
